export const Environment = {
  production: false,
  server: 'https://v2-api.link2hope.com/',
  apiUrl: 'api/',
  perPage: 20,
  isTestEnv: false,
  googleMapsApiKey: 'AIzaSyC8V_M3PMyrcxz6a0ScrJ0AcXQF-6jkw4c',
  mapboxApiUrl: 'https://api.mapbox.com/geocoding/v5/mapbox.places/',
  mapbox_Token: 'pk.eyJ1IjoicGFzc2lvbmRldiIsImEiOiJjandqem9xbmkwaDgxNGFxZ2VwcXlmaXlzIn0.LnISKimehOGVZtLucxbZng',
  hostMap: {
    'roanoke.link2hope.com' : 'roanoke',
    'mtn.link2hope.com' : 'mtn',
    'richmond.link2hope.com' : 'richmond',
    'tampa.link2hope.com' : 'tampa',
    'navigator.link2hope.com' : 'navigator',
  },
  featured_resource: {
    "mtn": {
      "get": 727,
      "give": 681,
    },
    "roanoke": {
      "get": 727,
      "give": 681,
    },
    "richmond": {
      "get": 831,
      "give": 831,
    },
    "tampa": {
      "get": 831,
      "give": 831,
    },
    "navigator": {
      "get": 831,
      "give": 831,
    }
  }
};
